import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
// import { BiShow } from "react-icons/bi";
// import { AiOutlineStar, AiFillStar } from "react-icons/ai";
// import { FiShare2, FiBriefcase } from "react-icons/fi";
import { BiDotsVerticalRounded } from "react-icons/bi";
import DataTable from "react-data-table-component";
import { API_URL } from "../../../config/config";
import { categoryItems } from "../../Home/Category";

import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import SelectRouteModal from "../../../components/Modals/SelectRouteModal";
import ShareModal from "../../../components/Modals/ShareModal";
import "./Cemetery.scss";
import CreateNewRouteModal from "../../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../../components/Modals/PointsListingModal";
import ReportSuggestionModal from "../../../components/Modals/ReportSuggestionModal";
import { toast } from "react-toastify";
import {
  routeDetail,
  updateRouteDetail,
} from "../../../services/myRoute.service";
import { useSelector } from "react-redux";
import Pagination from "../../../components/Pagination/Pagination";
// import card_image from "../../../assets/card_image.png";
import { IoHeartOutline, IoHeartSharp, IoShareSocial } from "react-icons/io5";

const TableView = ({
  name,
  categoryTitle,
  categoryIcon,
  categoryItem,
  totalCount,
  pageSize,
  setPageSize,
  setCurrentPage,
  addToFavorite,
  removeFromFavorite,
  currentPage,
}) => {
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [routeName, setRouteName] = useState(null);
  const [route, setRoute] = useState(null);
  const [pointName, setPointName] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [mkmID, setMkmId] = useState();
  const [link, setLink] = useState("");

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };
  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const addToRoute = (id, d) => {
    setMkmId(id);
    setPointName(d);
    setShowModal(true);
  };

  const share = (id, poi) => {
    var data;
    if (name === "Tzadikim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id}/${poi}`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return (categoryItem ?? []).slice(firstPageIndex, lastPageIndex);
  }, [categoryItem, currentPage, pageSize]);

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }

        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData?.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            setShowSpinner(true);
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowSpinner(false);
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              }
            );
            setShowSpinner(false);
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
          setShowSpinner(false);
        }
      } catch (error) {
        console.log(error);
        setShowSpinner(false);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setShowSpinner(false);
    }
  };

  const handlePerRowsChange = async (newPageSize, pageSize) => {
    setPageSize(newPageSize);
  };

  const customStyles = {
    tableWrapper: {
      style: { overflowX: "auto" },
    },
    table: {
      style: {
        backgroundColor: "transparent",
        minWidth: "1150px",
      },
    },
    headRow: {
      style: {
        height: "50px",
        borderRadius: "5px",
        borderWidth: "1px",
        border: "1px solid #81818133",
        background: "#F5F5F5",
        marginBottom: "16px",
      },
    },
    headCells: {
      style: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0%",
        color: "#494949",
        textTransform: "none",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    rows: {
      style: {
        borderRadius: "3.75px",
        borderWidth: "0.7px",
        border: "0.7px solid #B1AFAD",
        borderBottom: "0.7px solid #B1AFAD !important",
        backgroundColor: "transparent",
        marginBottom: "16px",
      },
      stripedStyle: {
        backgroundColor: "transparent",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0,0,0,0.05)",
        transitionDuration: "0.25s",
        borderRadius: "3.75px",
      },
      cells: {
        style: {
          backgroundColor: "transparent",
          paddingLeft: "0px",
          paddingRight: "0px",
        },
      },
    },
  };

  const columns = [
    {
      name: "Image",
      sortable: true,
      cell: (d) => (
        <img
          src={
            d?.imageIDs?.length > 0
              ? `${API_URL}/api/mkm/getimage/${d?.imageIDs?.[0]}`
              : categoryItems.find((item) => item.showTitle === categoryTitle)
                  ?.icon
          }
          alt=""
          style={{
            height: "70px",
            width: "70px",
            marginBlock: "11px",
            borderRadius: "5px",
          }}
        />
      ),
      width: "13%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "13%" },
    },
    {
      name: "Place Name",
      selector: (row) => row?.title,
      sortable: true,
      cell: (d) =>
        name === "Tzadikim" ? (
          <Link
            to={`/category-detail/?tzadikimId=${d?.tzadikimID}&cor${d?.poi}`}
            state={{
              categoryName: name,
              categoryTitle: categoryTitle,
              categoryIcon: categoryIcon,
            }}
          >
            <span className="link_route">{d?.title}</span>
          </Link>
        ) : (
          <Link
            to={`/category-detail/?MkmId=${d?.mkmID}&cor${d?.poi}`}
            state={{
              categoryName: name,
              categoryTitle: categoryTitle,
              categoryIcon: categoryIcon,
            }}
          >
            <span className="link_route">{d?.title}</span>
          </Link>
        ),
      width: "16.5%",
      grow: 0,
      style: {
        paddingLeft: "12px",
        paddingRight: "12px",
        maxWidth: "16.5%",
        fontWeight: 700,
      },
    },
    {
      name: "Location",
      selector: (row) => row?.cityE + " " + row?.stateE,
      sortable: true,
      width: "18%",
      grow: 0,
      style: {
        paddingLeft: "12px",
        paddingRight: "12px",
        maxWidth: "18%",
        fontFamily: "Lato",
        fontSize: "16px",
        color: "#494949",
      },
    },
    {
      name: "Contact",
      selector: (row) => row?.contact,
      sortable: true,
      cell: (d) => (
        <span
          className="link_route"
          style={{ fontSize: "16px", color: "#494949" }}
        >
          N/A
        </span>
      ),
      width: "12%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "12%" },
    },
    {
      name: "Add to Route",
      selector: (row) => row?.add_route,
      sortable: true,
      cell: (d) => {
        return (
          <div
            className="btn_add_to_route"
            type="button"
            onClick={() => addToRoute(d?.mkmID, d)}
          >
            Add to Route
          </div>
        );
      },
      width: "20%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "20%" },
    },
    {
      name: "Actions",
      selector: (row) => row?.mkmID,
      sortable: true,
      cell: (d, index) => {
        return (
          <div className="actions">
            <div className="favourite_icon">
              {d?.userFavorite === true ? (
                <div
                  style={{ color: "#F57D2B" }}
                  onClick={() =>
                    removeFromFavorite(
                      d?.tzadikimID
                        ? { tzadikimID: d?.tzadikimID }
                        : { mkmID: d?.mkmID },
                      d?.userFavorite
                    )
                  }
                >
                  {/* <AiFillStar size={20} /> */}
                  <IoHeartSharp size="22px" />
                </div>
              ) : (
                <div
                  style={{ color: "#787776" }}
                  onClick={() =>
                    addToFavorite(
                      d?.tzadikimID
                        ? { tzadikimID: d?.tzadikimID }
                        : { mkmID: d?.mkmID },
                      d?.userFavorite
                    )
                  }
                >
                  <IoHeartOutline size="22px" />
                </div>
              )}
            </div>
            <Button
              className="link_share"
              onClick={() =>
                share(d?.tzadikimID ? d?.tzadikimID : d?.mkmID, d?.poi)
              }
            >
              <IoShareSocial size="22px" />
            </Button>
            {name === "Tzadikim" ? (
              <Button className="link_view_more">
                <Link
                  style={{ color: "#f57d2b" }}
                  to={`/category-detail/?tzadikimId=${d?.tzadikimID}&cor=${d?.poi}`}
                  state={{
                    categoryName: name,
                    categoryTitle: categoryTitle,
                    categoryIcon: categoryIcon,
                  }}
                >
                  view more
                </Link>
              </Button>
            ) : (
              <Button className="link_view_more">
                <Link
                  style={{ color: "#f57d2b" }}
                  to={`/category-detail/?MkmId=${d?.mkmID}&cor=${d?.poi}`}
                  state={{
                    categoryName: name,
                    categoryTitle: categoryTitle,
                    categoryIcon: categoryIcon,
                  }}
                >
                  view more
                </Link>
              </Button>
            )}
            <Dropdown
              className="moreInfo"
              toggle={() =>
                setMenuOpen(index === dropdownMenuOpen ? null : index)
              }
              isOpen={index === dropdownMenuOpen}
            >
              <DropdownToggle
                className="link_dots"
                style={{ padding: "0px", height: "45px", width: "45px" }}
              >
                <BiDotsVerticalRounded size="22px" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link
                    to={`/along-the-way-to-here/${d?.poi}`}
                    state={{
                      categoryName: name,
                      categoryTitle: categoryTitle,
                      categoryIcon: categoryIcon,
                    }}
                    className="breadcrumb_item1"
                  >
                    Along the way to here
                  </Link>
                </DropdownItem>
                <DropdownItem
                  onClick={() =>
                    reportSuggestion(
                      d?.title,
                      d?.tzadikimID ? d?.tzadikimID : d?.mkmID
                    )
                  }
                >
                  Report suggestion
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        );
      },
      width: "16%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "16%" },
    },
  ];

  return (
    <div className="table_view" style={{ marginBottom: "80px" }}>
      <SelectRouteModal
        route={route}
        setRoute={setRoute}
        showModal={showModal}
        toggle={toggle}
        createNewRoute={createNewRoute}
        selectRoute={selectRoute}
        showSpinner={showSpinner}
      />
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        mkmID={mkmID}
      />
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />
      <div className="table_scroll_x">
        <DataTable
          columns={columns}
          data={categoryItem}
          customStyles={customStyles}
          // pagination
          // paginationServer
          // paginationTotalRows={totalCount}
          // paginationPerPage={pageSize}
          // paginationRowsPerPageOptions={[10, 20, 50, 100]}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={(currentPage) => setCurrentPage(currentPage)}
        />
      </div>
      <div style={{ marginTop: "-16px" }}>
        {(totalCount ?? 0) > 0 && (
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>
    </div>
  );
};

export default TableView;
